/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const ST = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="svg696"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1333.33 800"
    {...props}
  >
    <defs>
      <style>
        {`
.cls-1 {
  clipPath: url(#clippath-20);
}
.cls-2 {
  clipPath: url(#clippath-11);
}
.cls-3 {
  clipPath: url(#clippath-16);
}
.cls-4 {
  clipPath: url(#clippath-33);
}
.cls-5 {
  clipPath: url(#clippath-32);
}
.cls-6 {
  opacity: .99;
}
.cls-7 {
  clipPath: url(#clippath-2);
}
.cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {
  strokeWidth: 0px;
}
.cls-8, .cls-14 {
  fillRule: evenodd;
}
.cls-18 {
  clipPath: url(#clippath-13);
}
.cls-9 {
  fill: #e30613;
}
.cls-19 {
  clipPath: url(#clippath-25);
}
.cls-20 {
  clipPath: url(#clippath-15);
}
.cls-21 {
  clipPath: url(#clippath-6);
}
.cls-11 {
  fill: #159a34;
}
.cls-22 {
  clipPath: url(#clippath-26);
}
.cls-12, .cls-23, .cls-24 {
  fill: none;
}
.cls-25 {
  clipPath: url(#clippath-7);
}
.cls-26 {
  clipPath: url(#clippath-21);
}
.cls-27 {
  clipPath: url(#clippath-34);
}
.cls-28 {
  clipPath: url(#clippath-1);
}
.cls-29 {
  clipPath: url(#clippath-4);
}
.cls-30 {
  clipPath: url(#clippath-27);
}
.cls-23 {
  strokeWidth: 1.98px;
}
.cls-23, .cls-24 {
  stroke: #000;
  strokeMiterlimit: 15.12;
}
.cls-31 {
  clipPath: url(#clippath-12);
}
.cls-13, .cls-14 {
  fill: #fff;
}
.cls-32 {
  clipPath: url(#clippath-24);
}
.cls-33 {
  clipPath: url(#clippath-30);
}
.cls-34 {
  clipPath: url(#clippath-22);
}
.cls-35 {
  clipPath: url(#clippath-9);
}
.cls-36 {
  clipPath: url(#clippath);
}
.cls-24 {
  strokeWidth: .99px;
}
.cls-37 {
  clipPath: url(#clippath-19);
}
.cls-38 {
  clipPath: url(#clippath-31);
}
.cls-39 {
  clipPath: url(#clippath-3);
}
.cls-40 {
  clipPath: url(#clippath-8);
}
.cls-15 {
  fill: #f6f5f4;
}
.cls-41 {
  clipPath: url(#clippath-29);
}
.cls-16 {
  fill: #ebbd00;
}
.cls-42 {
  clipPath: url(#clippath-18);
}
.cls-43 {
  clipPath: url(#clippath-14);
}
.cls-44 {
  clipPath: url(#clippath-17);
}
.cls-45 {
  clipPath: url(#clippath-5);
}
.cls-17 {
  fill: #fcd116;
}
.cls-46 {
  clipPath: url(#clippath-10);
}
.cls-47 {
  clipPath: url(#clippath-23);
}
.cls-48 {
  clipPath: url(#clippath-28);
}
`}
      </style>
      <clipPath id="clippath">
        <path
          className="cls-12"
          d="m461.03,444.26c0,113.6,92.13,205.71,205.74,205.71h0c113.59,0,205.7-92.11,205.7-205.71h0V151.98l-411.44-.06v292.33Z"
        />
      </clipPath>
      <clipPath id="clippath-1">
        <rect
          className="cls-12"
          y="0"
          width="1333.33"
          height="800"
        />
      </clipPath>
    </defs>
    <g id="g704">
      <path
        id="path706"
        className="cls-17"
        d="m0,400h1333.33V0H0v400Z"
      />
      <path
        id="path708"
        className="cls-10"
        d="m0,799.87h1333.33v-400H0v400Z"
      />
      <path
        id="path710"
        className="cls-17"
        d="m461.04,151.93h411.43v275.01h-411.43V151.93Z"
      />
      <path
        id="path712"
        className="cls-10"
        d="m461.04,183.33h411.43v27.07h-411.43v-27.07Z"
      />
      <path
        id="path714"
        className="cls-10"
        d="m461.04,237.46h411.43v27.07h-411.43v-27.07Z"
      />
      <path
        id="path716"
        className="cls-10"
        d="m461.04,291.6h411.43v27.07h-411.43v-27.07Z"
      />
      <path
        id="path718"
        className="cls-10"
        d="m461.04,345.73h411.43v27.07h-411.43v-27.07Z"
      />
      <path
        id="path720"
        className="cls-10"
        d="m461.04,399.86h411.43v27.07h-411.43v-27.07Z"
      />
      <g id="g722">
        <g className="cls-36">
          <g id="g724">
            <path
              id="path730"
              className="cls-13"
              d="m461.04,660.79h411.43v-233.86h-411.43v233.86Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default memo(ST);
